module.exports = __webpack_public_path__ + "img/payment-failed.8d2c67aa.png";